<div *ngIf="!!selectedRow" fxFlexFill>
  <div class="detailsPanelBody" *ngIf="!!dataDetail">
    <form class="example-form" #updateForm="ngForm" >

      <!--  ************************************  -->
      <!--            CUSTOMER NAME               -->
      <!--  ************************************  -->
      <mat-form-field class="fullWidthField">
        <mat-label>{{'CUSTOMER.TITLE' | translate}}</mat-label>
        <input matInput required #customerTitle="ngModel" type="text" name="customerTitle" [disabled]="!editMode" [(ngModel)]="dataDetail.title">
        <mat-error *ngIf="customerTitle.invalid">
          {{'CUSTOMER.TITLE_FIELD' | translate}} <strong>{{'COMMON.IS_REQUIRED' | translate}}</strong>
        </mat-error>
      </mat-form-field>

      <!--  ************************************  -->
      <!--            CUSTOMER EMAILS             -->
      <!--  ************************************  -->
      <mat-form-field class="fullWidthField">
        <mat-label>{{'CUSTOMER.EMAILS' | translate}}</mat-label>
        <input matInput #customerEmails="ngModel" [disabled]="!editMode"  pattern="{{gmService.MULTIPLE_EMAIL_PATTERN_VALIDATOR}}" type="text" name="customerEmails" (change)="createEmailList(emailList, customerEmails.invalid)" [(ngModel)]="emailList">
        <mat-error *ngIf="customerEmails.dirty && emailList !== '' && customerEmails.invalid">
          {{'CUSTOMER.EMAILS_FIELD' | translate}} <strong>{{'COMMON.IS_IN_WRONG_FORMAT' | translate}}</strong>
        </mat-error>
      </mat-form-field>

      <div *ngIf="editMode" style="margin: 5px 0">
        <button style="height: 40px" type="button" mat-raised-button color="primary" (click)="fileInput.click()">{{'CUSTOMER.PICTURE' | translate}}</button>
        <input hidden (change)="onFileSelected($event)" #fileInput type="file" id="file">
        <span *ngIf="!!selectedFile" style="margin-left: 5px"><i>{{selectedFile.name}}</i></span>
        <span *ngIf="!selectedFile && !!dataDetail.imageUrl"><i> {{imageFileNameFromUrl(dataDetail.imageUrl)}}</i></span>
        <button style="margin-left: 5px" *ngIf="!!selectedFile || !!dataDetail.imageUrl" type="button" mat-mini-fab color="primary"
                (click)="resetImage()"><mat-icon>close</mat-icon></button>
      </div>
    </form>

    <p *ngIf="!editMode && !!dataDetail.imageUrl" style="margin-top: 10px;">{{'CUSTOMER.PICTURE' | translate}}</p>

    <img style="max-width: 250px" *ngIf="!editMode && !!dataDetail.imageUrl" [src]="dataDetail.imageUrl" [alt]="dataDetail.title">
  </div>

</div>
